
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import vSelect from './vselect'
export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
Datetime,
XDialog
},
methods: {
changeli: function (ind, item) {

this.headerData.forEach(i => {

if (i.show !== this.headerData[ind].show) {
i.show = false
}
})

item.show = !item.show
console.log(item.name)
},
doThis: function (index, idlist, name) {
console.log(idlist)
console.log(name)
console.log(name === '内容类别')
if (name === '内容类别') {
this.contentType = idlist[index]
} else {
this.ruletype = idlist[index]
}
this.queryBtn()
},
ToggleClass (type) {
if (this.selects[type] === 0) {
this.selects[type] = 1
} else {
this.selects[type] = 0
}
console.log(this.selects[type])
},
handleToggleDrawer (type) {
this.show = true
console.log(this.show)
this.hightype = type
this.$refs.drawerLayout.toggle()
},
SetFalse () {
this.show = false
console.log(this.show)
},
async queryBtn () {
if (this.viewtype === 1) {
this.doQuery()
} else {
this.doQueryGroup()
}
},
async QueryMore (type) {
this.ruletype = type
this.viewtype = 1
this.queryBtn()
},
async next () {
this.currentPage--
await this.doQuery()
},
async perv () {
this.currentPage++
await this.doQuery()
},
async getEffectList (type) {
const queryPromise = await this.$http.get('/API/RuleSearch/EffectType'
, {params: {type: type}})
return queryPromise.data
},
async getContentList (type) {
const queryPromise = await this.$http.get('/API/RuleSearch/ContentType')
return queryPromise.data
},
async getRulesList (type) {
const queryPromise = await this.$http.get('/API/RuleSearch/RulesType')
console.log(queryPromise.data)
return queryPromise.data
},
async fullSearchChanage () {
this.fullsearchtype = document.getElementById('searchmor_type').value
this.queryBtn()
},
async orderChanage () {
this.orders = document.getElementById('orders_data').value
this.queryBtn()
},
async getYears () {
const queryPromise = await this.$http.get('/API/RuleSearch/Years')
return queryPromise.data
},
async getClassCount () {
const cc = await this.$http.get('/API/RuleSearch/FullSearchContentListSql'
, {params: {keyword: this.keyword, pageindex: this.currentPage, fullseachtype: this.fullsearchtype, ordetype: this.orders, pagesize: 10, effectType: this.effectType, contentType: this.contentType, title: this.title, no: this.rno, years: this.year, department: this.department, effdate: this.effectDate, pulishdate: this.publishDatenp}})
console.log(cc.data)
this.headerData = cc.data.Data
return cc.data
},
async viewChange () {
if (this.viewtype === 1) {
this.viewtype = 2
this.doQueryGroup()
} else {
this.doQuery()
this.viewtype = 1
}
console.log(this.viewtype)
},
async doQuery () {



try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/RuleSearch/FullSearchListSql'
, {params: {keyword: this.keyword, pageindex: this.currentPage, fullseachtype: this.fullsearchtype, ordetype: this.orders, pagesize: 10, effectType: this.effectType, contentType: this.contentType, title: this.title, no: this.rno, years: this.year, department: this.department, effdate: this.effectDate, pulishdate: this.publishDatenp, rulestype: this.ruletype}})
this.queryResult = queryPromise.data
console.log(this.queryResult)
this.$vux.loading.hide()
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
this.getClassCount()
},
async doFirstQuery () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/RuleSearch/FullSearchListSql'
, {params: {keyword: this.keyword, pageindex: this.currentPage, fullseachtype: this.fullsearchtype, ordetype: this.orders, pagesize: 10, effectType: this.effectType, contentType: this.contentType, title: this.title, no: this.rno, years: this.year, department: this.department, effdate: this.effectDate, pulishdate: this.publishDatenp, rulestype: this.ruletype}})
this.queryResult = queryPromise.data
console.log(this.queryResult)
this.$vux.loading.hide()
if (this.queryResult.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
this.getClassCount()
},
async doQueryGroup () {
try {
console.log(this.fullsearchtype)
console.log('orders' + this.orders)
this.$vux.loading.show({ text: ' 数据载入中' })
console.log('effect select:' + this.effect)
const queryPromise = await this.$http.get('/API/RuleSearch/FullSearchGroupSql'
, {params: {keyword: this.keyword, fullseachtype: this.fullsearchtype, ordetype: this.orders, effectType: this.effectType, contentType: this.contentType, title: this.title, no: this.rno, years: this.year, department: this.department, effdate: this.effectDate, pulishdate: this.publishDate, rulestype: this.ruletype}})
this.queryResultGroup = queryPromise.data
console.log(this.queryResultGroup)
this.$vux.loading.hide()
if (this.queryResultGroup.Data.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
this.getClassCount()
},
async showDesc (itemid) {
try {
this.$router.push({name: 'RulesSearchDetails', query: {guid: itemid}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
async showP_CIQDocDesc (index) {
let current = this.currentItem.P_CIQDoclst[index]
this.$router.push({name: 'PCIQDocDetail', params: {Item: current, ItemVersion: {CPV_Date: ''}}})
},
clear () {
this.year = ''
this.keyword = ''
this.title = ''
this.rno = ''
this.ruletype = ''
this.effectDate = ''
this.department = ''
this.publishDate = ''
this.effect = ''
this.contentType = ''
}
},
data () {
return {
queryResult: {Data: [], TotalPage: 0},
queryResultGroup: {Data: [], TotalPage: 0},
p_code: '',
keyword: '',
fullsearchtype: 0,
orders: 1,
viewtype: 1,
show: false,
hightype: 2,
desc: null,
rno: '',
department: '',
yearList: [],
selects: [0, 0, 0],
year: '',
p_name: '',
ruletype: '',
ruletypeList: ['', '法律', '法规', '海关规章', '其他部门规章', '海关规范性文件', '其他'],
effect: '',
effectList: ['', '有效', '失效', '部分修改'],
contentType: '',
contenttypeList: ['', '综合类', '运输工具监管类', '进出口货物监管类', '进出境物品监管类', '关税征收管理类', '原产地规则类', '加工贸易保税监管类', '案件稽查类', '企业管理类', '知识产权类', '检验检疫类', '商品检验类', '卫生检验类', '食品安全类', '动植物检疫类', '其他'],
effectDate: null,
publishDate: null,
currentPage: 1,
title: '',
headerData: []
}
},
beforeCreate: function () {

},
async activated () {








this.yearList = (await this.getYears()).sort().reverse()
this.yearList.unshift('')
if (this.yearList.length > 0) {
console.log(this.yearList)

}
this.doFirstQuery()
}
}



// WEBPACK FOOTER //
// ./src/components/RulesSearchIndex.vue